import { Button, Icon } from 'semantic-ui-react'
import rest from '../../rest'
import { saveAs } from 'file-saver'

import './styles.scss'
import { useState } from 'react'

export function Print ({
    title="Exportar como documento do Word", template='item_trabalho', id=0, disabled=false, extensao='docx', styles={}, setError={}, inverted=false
}) {
    
    const clearError = () => {
        setError({})
    }

    const onPrint = async () => {
        // Chama serviço rest para imprimir
        if (!disabled) {
            const endpoint = template + "/" + (id?id+"/":"") + (template.includes('?')?'&':'?') + "formato=" + extensao
            const response = await rest(`${endpoint}`).then(json => {
                var file
                const base64data = json.base64
                const bs = atob(base64data)
                const buffer = new ArrayBuffer(bs.length)
                const ba = new Uint8Array(buffer)
                for (let i = 0; i < bs.length; i++) {
                    ba[i] = bs.charCodeAt(i)
                }
                file = new Blob([ba], { type: json.filetype })
                saveAs(file, json.filename)
            }).catch(err => {
                setError(err.detail)
            })
        
        }
    }

    return (
        <Button className="buttonIcon" icon disabled={disabled} styles={styles}>
            <Icon 
                className="Icon" 
                name='print' 
                disabled={disabled} 
                onClick={onPrint} 
                title={title} 
                size='large' />    
        </Button>
    )
}
